const logoutEvent = new CustomEvent('userLoggedOut', {
  detail: {
    loggedIn: false,
  }
});

export default () => document.dispatchEvent(logoutEvent);
